<template>
  <div class="header">
    <div class="header-content">
      <div class="logo">
        <img src="../assets/images/powerslide-blue.svg" v-on:click="landing" class="left-logo" alt="Powerslide Logo" />
      </div>

      <div class="nav-container">
        <ul>
          <li class="dropdown-btn">
            <div class="item" v-on:click="solutions">Solutions</div>
            <!-- <div class="dropdown-content">
              <div class="dropdown-link" v-on:click="goTo('restaurants')">Restaurants</div>
              <div class="dropdown-link">Healthcare</div>
              <div class="dropdown-link">Hospitality</div>
              <div class="dropdown-link">Entertainment Venues</div>
              <div class="dropdown-link">Automotive</div>
              <div class="dropdown-link">Retail</div>
              <div class="dropdown-link">Supermarkets</div>
              <div class="dropdown-link">Fitness</div>
              <div class="dropdown-link">Financial</div>
              <div class="dropdown-link">Real Estate</div>
              <div class="dropdown-link">Senior Living</div>
              <div class="dropdown-link">Education</div>
              <div class="dropdown-link">Franchises</div>
              <div class="dropdown-link">Offices/Manufacturing</div>
              <div class="dropdown-link">Advertising Networks</div>
            </div> -->
          </li>
          <!-- <li>
            <div class="item">Templates</div>
          </li> -->
          <li>
            <div class="item" v-on:click="login">Login</div>
          </li>
          <li>
            <div class="item" v-on:click="getStarted">Get Started Today!</div>
          </li>
        </ul>
      </div>

      <div class="menu" v-on:click="toggleSidebar">
        <img src="../assets/images/menu-icon.svg" class="menu-icon" alt="Navigation Menu" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',

  data () {
    return {

    }
  },

  methods: {
    createAccount: function () {
      this.$router.push('create-account')
    },

    getStarted: function () {
      if (this.$route.path !== '/get-started') {
        this.$router.push('get-started')
      }
    },

    landing: function () {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },

    login: function () {
      this.$router.push('login')
    },

    solutions: function () {
      if (this.$route.path !== '/solutions') {
        this.$router.push('/solutions')
      }
    },

    templates: function () {
      if (this.$route.path !== '/templates') {
        this.$router.push('/templates')
      }
    },

    toggleSidebar: function () {
      this.$parent.forceSidebarVisible = !this.$parent.forceSidebarVisible
    }
  }
}
</script>

<style scoped>
  .button {
    padding: .5em .75em;
  }

  .colored {
    background: var(--secondary);
    color: white;
  }

  .colored:hover {
    background: var(--secondary-dark) !important;
  }

  .dropdown-content {
    background-color: #efefef;
    border-radius: 6px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    display: none;
    min-width: 230px;
    overflow: auto;
    position: absolute;
    z-index: 1;
  }

  .dropdown-link {
    color: black;
    display: block;
    padding: 12px 16px;
    text-decoration: none;
  }

  .dropdown-link:hover {
    background: var(--secondary);
    color: white;
    cursor: pointer;
  }

  .dropdown-btn:hover .dropdown-content {display: block;}

  .header {
    background: white;
    border-bottom: 1px solid #efefef;
    padding: 1em;
    position: fixed;
    text-align: right;
    top: 0;
    width: 100%;
    z-index: 999;
  }

  .header-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .item {
    cursor: pointer;
    font-size: 1.1em;
  }

  .item:after {
    background: none repeat scroll 0 0 transparent;
    bottom: 0;
    content: "";
    display: block;
    height: 2px;
    left: 50%;
    position: absolute;
    background: var(--secondary);
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
  }

  .item:hover:after {
    width: 100%;
    left: 0;
  }

  .item:hover {
    color: var(--secondary) !important;
  }

  .left-logo {
    height: 50px;
    position: absolute;
    top: -3px;
  }

  li {
    border-left: 1em solid transparent;
    border-right: .5em solid transparent;
    border-top: .5em solid transparent;
    display: table-cell;
    padding: 0 0 .5em 0;
    position: relative;
  }

  .logo {
    cursor: pointer;
    display: inline-block;
    margin-right: auto;
    text-transform: uppercase;
  }

  .menu {
    display: none;
  }

  .menu-icon {
    height: 30px;
    position: relative;
    top: 2px;
    width: 30px;
  }

  .nav-container {
    display: inline-block;
  }

  ul {
    display: table;
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: center;
    width: 100%;
  }

  @media only screen and (max-width: 600px) {
    .item {
      display: none;
    }

    .logo {
      padding: .5em 0em
    }

    .menu {
      display: inline-block;
    }
  }
</style>
